import React from 'react';

const SkillsBadges = ({ skills }) => {
  // Don't render anything if no skills are provided
  if (!skills || !Array.isArray(skills) || skills.length === 0) {
    return null;
  }

  return (
    <div className="mb-12 text-center">
      <span className="text-sm text-gray-500 mr-2">Assessing:</span>
      {skills.map((skill, index) => (
        <span 
          key={index} 
          className="inline-block bg-blue-100 text-blue-800 text-xs px-2 py-1 rounded mr-1 mb-1"
        >
          {skill}
        </span>
      ))}
    </div>
  );
};

export default SkillsBadges;
